import React, { PropsWithChildren } from "react";

export const ChatContext = React.createContext(false);

const ChatContextProvider = (props: PropsWithChildren<{}>) => {
    return (
        <ChatContext.Provider value={true}>
            {props.children}
        </ChatContext.Provider>
    );
};

export { ChatContextProvider };
